import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'


import removeProjectBudgetMutation from '../../queries/server/mutations/remove_project_budgets'
import editProjectLocalMutation from '../../queries/client_side/mutations/edit_project'
import ProjectBudgetBreakdownInput from "./ProjectBudgetBreakdownInput";

class ProjectBudgetBreakdownListItem extends Component {

    state = {
        buttonsDisplayed: false,
        editing: false
    }

    displayButtons = (bool) => {
        this.setState({buttonsDisplayed: bool})
    }

    render() {

        const {id, description, amount, project_id, parent_id} = this.props
        
        const {buttonsDisplayed, editing} = this.state
        
        if(editing) return (
            <div className="pt-1 pb-1">
                <ProjectBudgetBreakdownInput
                    project_id={project_id}
                    parent_id={parent_id}
                    id={id}
                    description={description}
                    amount={amount}
                    onAdded={() => this.setState({editing: false})}
                    onCancel={() => this.setState({editing: false})}
                    successMessage="Budget Breakdown Updated"
                />
            </div>

        )
        

        const style = buttonsDisplayed ? {backgroundColor: "#f7faff"} : {}

        return (
            <Mutation mutation={removeProjectBudgetMutation}>
                {(removeProjectBudgetMutationFunc, {loading}) => (
                    <div
                        className={`d-flex flex-row justify-content-between align-items-center ${buttonsDisplayed ? 'pt-1 pb-1' : 'pt-2 pb-2'}`}
                        style={style}
                        onMouseEnter={() => this.displayButtons(true)}
                        onMouseLeave={() => this.displayButtons(false)}
                    >
                        <span className="font-weight-light" style={{flex: 1}}>{description}</span>
                        <span className="text-muted">{Intl.NumberFormat('en-GB', {
                            style: 'currency',
                            currency: 'GBP'
                        }).format(amount)}</span>
                        {buttonsDisplayed && <div className="d-flex flex-row ml-2">
                            <Button
                                size="sm"
                                color="warning"
                                className="mr-1 square-btn"
                                onClick={() => this.setState({editing: true})}
                            >
                                <FontAwesomeIcon color="#fff" icon="edit"/>
                            </Button>

                            <Mutation mutation={editProjectLocalMutation}>
                                {(editProjectLocalMutationFunc) => (
                                    <Button
                                        size="sm"
                                        color="danger"
                                        className="square-btn"
                                        onClick={() => {
                                            removeProjectBudgetMutationFunc({variables: {project_id, ids: [id]}})
                                                .then(({data}) => {
                                                    editProjectLocalMutationFunc({variables: {data: data.removeProjectBudgets}})
                                                    toast.success('Budget Breakdown Removed', {autoClose: 2000})
                                                })
                                                .catch(e => toast.error(e.message, {autoClose: false}))
                                        }}
                                        disabled={loading}
                                    >
                                        <FontAwesomeIcon color="#fff" icon="trash-alt"/>
                                        {loading && 'Removing...'}
                                    </Button>
                                )}
                            </Mutation>

                        </div>}
                    </div>
                )}
            </Mutation>
        )
    }


}

ProjectBudgetBreakdownListItem.propTypes = {
    id: PropTypes.number.isRequired,
    project_id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    parent_id: PropTypes.number.isRequired
}

export default ProjectBudgetBreakdownListItem